import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { Sparkles } from 'atoms/animations/Sparkles';
import { Star } from 'atoms/icons/Star';
import { ConditionalWrapper } from 'atoms/layout/ConditionalWrapper';
import { Horizontal } from 'atoms/layout/flex';
import { range } from 'lib/arrays';
import type { unitMapping } from 'lib/style';

const Root = styled(Horizontal).attrs({ center: true })`
  display: inline-flex;
  gap: 1px;
  min-width: var(--quadruple-unit);
  padding: var(--half-unit) var(--half-unit);
  border-radius: var(--quadruple-unit);
  border: 1px solid var(--c-nd-500);
  background: linear-gradient(
      to bottom right,
      transparent 50%,
      var(--c-nd-150) 51%
    ),
    var(--c-nd-50-opaque);

  &.tierZero {
    color: var(--c-yellow-200);
  }
`;

type Props = {
  count: number;
  size?: keyof typeof unitMapping;
  sparkles?: boolean;
  children?: ReactNode;
};

export const Stars = ({
  count,
  size = 1,
  sparkles = false,
  children,
}: Props) => {
  return (
    <ConditionalWrapper wrap={sparkles} Wrapper={Sparkles}>
      <Root className={classNames({ tierZero: sparkles }, 'text-center')}>
        {range(count).map(i => (
          <Star key={i} size={size} />
        ))}
        {children}
      </Root>
    </ConditionalWrapper>
  );
};
